<n-data-table id="unavailable-lun-table"
    [data]="luns"
    [config]="tableConfig"
    [columnDefs]="columnDefs">
</n-data-table>
